import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/dispute-background-ornament.svg'
import _imports_1 from '@/app/ui/assets/svg/ellipse.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_plane-booking-black.svg'
import _imports_3 from '@/app/ui/assets/svg/download-new.svg'
import _imports_4 from '@/app/ui/assets/svg/ics_o_truck-booking-black.svg'
import _imports_5 from '@/app/ui/assets/svg/ics_o_boat.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-af0b16ac")

_pushScopeId("data-v-af0b16ac")
const _hoisted_1 = {
  key: 0,
  class: "mt-4 relative bg-white rounded-2xl px-4 py-2 border border-red-lp-2800 mb-4"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "absolute rounded-tr-2xl right-0 top-0 w-30",
  alt: ""
}, null, -1)
const _hoisted_3 = { class: "relative z-10" }
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = { class: "flex flex-col gap-1" }
const _hoisted_6 = { class: "flex items-center gap-x-3" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center gap-x-2"
}
const _hoisted_8 = {
  style: {"line-height":"100%"},
  class: "text-xl font-bold text-red-lp-2000"
}
const _hoisted_9 = {
  style: {"line-height":"100%"},
  class: "text-xl text-black-lp-300"
}
const _hoisted_10 = {
  key: 1,
  class: "flex items-center gap-x-2"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", {
  style: {"line-height":"100%"},
  class: "text-16px text-black-lp-100 font-medium"
}, "dengan selisih berat", -1)
const _hoisted_12 = { class: "flex items-center gap-x-2" }
const _hoisted_13 = { class: "flex items-center gap-x-6" }
const _hoisted_14 = {
  key: 0,
  class: "text-12px"
}
const _hoisted_15 = {
  key: 1,
  class: "mt-1"
}
const _hoisted_16 = {
  key: 0,
  style: {"width":"4px","height":"4px"},
  src: _imports_1
}
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "text-12px text-red-lp-2000 underline" }, "Download", -1)
const _hoisted_18 = { class: "flex items-center gap-x-4" }
const _hoisted_19 = {
  key: 0,
  class: "flex items-center gap-x-3"
}
const _hoisted_20 = {
  key: 0,
  src: _imports_2,
  class: "w-6",
  alt: "Pesawat"
}
const _hoisted_21 = {
  key: 2,
  class: "flex flex-col gap-1"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("span", {
  style: {"line-height":"100%"},
  class: "text-12px text-black-lp-300"
}, "Pesawat", -1)
const _hoisted_23 = { class: "flex items-center gap-x-1" }
const _hoisted_24 = { class: "text-16px font-semibold text-black-lp-300" }
const _hoisted_25 = { class: "text-12px" }
const _hoisted_26 = {
  key: 1,
  style: {"width":"6px","height":"6px"},
  src: _imports_1
}
const _hoisted_27 = {
  key: 2,
  class: "flex items-center gap-x-3"
}
const _hoisted_28 = {
  key: 0,
  src: _imports_4,
  class: "w-6",
  alt: "Truk"
}
const _hoisted_29 = {
  key: 2,
  class: "flex flex-col gap-1"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("span", {
  style: {"line-height":"100%"},
  class: "text-12px text-black-lp-300"
}, "Truk", -1)
const _hoisted_31 = { class: "flex items-center gap-x-1" }
const _hoisted_32 = { class: "text-16px font-semibold text-black-lp-300" }
const _hoisted_33 = { class: "text-12px" }
const _hoisted_34 = {
  key: 3,
  style: {"width":"6px","height":"6px"},
  src: _imports_1
}
const _hoisted_35 = {
  key: 4,
  class: "flex items-center gap-x-3"
}
const _hoisted_36 = {
  key: 0,
  src: _imports_5,
  class: "w-6",
  alt: "Kapal"
}
const _hoisted_37 = {
  key: 2,
  class: "flex flex-col gap-1"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("span", {
  style: {"line-height":"100%"},
  class: "text-12px text-black-lp-300"
}, "Kapal", -1)
const _hoisted_39 = { class: "flex items-center gap-x-1" }
const _hoisted_40 = { class: "text-16px font-semibold text-black-lp-300" }
const _hoisted_41 = { class: "text-12px" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Lainnya ")
const _hoisted_43 = { class: "flex items-center justify-between" }
const _hoisted_44 = { class: "flex gap-x-2 items-center" }
const _hoisted_45 = {
  key: 0,
  src: _imports_2,
  class: "w-5",
  alt: "Pesawat"
}
const _hoisted_46 = /*#__PURE__*/_createVNode("span", { class: "text-gray-lp-300 text-sm font-semibold" }, "SMU dengan minimum berat per koli", -1)
const _hoisted_47 = { class: "flex items-center gap-x-1" }
const _hoisted_48 = { class: "text-16px font-semibold text-red-lp-2000" }
const _hoisted_49 = { class: "text-14px" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icons = _resolveComponent("Icons")!

  return (_ctx.shouldShowSummary)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                (!_ctx.isLoadingCargoDispute)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _createVNode("span", _hoisted_8, _toDisplayString(_ctx.cargoDisputeSummaryData.totalCargoDispute) + "/" + _toDisplayString(_ctx.cargoDisputeSummaryData.totalCargoData), 1),
                      _createVNode("span", _hoisted_9, "(" + _toDisplayString(_ctx.formatCurrency(_ctx.cargoDisputeSummaryData.totalPercentage)) + "%)", 1)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_10, [
                      _createVNode(_component_Skeleton, {
                        height: "40px",
                        width: "5rem"
                      })
                    ])),
                _hoisted_11
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("div", _hoisted_13, [
                  (!_ctx.isLoadingCargoDispute)
                    ? (_openBlock(), _createBlock("span", _hoisted_14, "Data " + _toDisplayString(_ctx.dateRangeDisplay), 1))
                    : (_openBlock(), _createBlock("div", _hoisted_15, [
                        _createVNode(_component_Skeleton, {
                          height: "20px",
                          width: "3rem"
                        })
                      ]))
                ]),
                (_ctx.cargoDisputeSummaryData.totalCargoDispute > 0)
                  ? (_openBlock(), _createBlock("img", _hoisted_16))
                  : _createCommentVNode("", true),
                (_ctx.cargoDisputeSummaryData.totalCargoDispute > 0)
                  ? (_openBlock(), _createBlock("div", {
                      key: 1,
                      id: "lp-cargo-list-dispute-summary-download-all",
                      class: "flex items-center gap-x-1 cursor-pointer",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDownload('all')))
                    }, [
                      _hoisted_17
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_18, [
              (_ctx.cargoDisputeSummaryData.totalPlaneData > 0 || _ctx.cargoDisputeSummaryData.totalPlaneDispute > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_19, [
                    (!_ctx.isLoadingCargoDispute)
                      ? (_openBlock(), _createBlock("img", _hoisted_20))
                      : (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 1,
                          height: "30px",
                          width: "30px"
                        })),
                    (!_ctx.isLoadingCargoDispute)
                      ? (_openBlock(), _createBlock("div", _hoisted_21, [
                          _hoisted_22,
                          _createVNode("div", _hoisted_23, [
                            _createVNode("span", _hoisted_24, _toDisplayString(_ctx.cargoDisputeSummaryData.totalPlaneDispute) + "/" + _toDisplayString(_ctx.cargoDisputeSummaryData.totalPlaneData), 1),
                            _createVNode("span", _hoisted_25, "(" + _toDisplayString(_ctx.formatCurrency(_ctx.cargoDisputeSummaryData.totalPlanePercentage)) + "%)", 1),
                            _createVNode("img", {
                              id: "lp-cargo-list-dispute-summary-download-plane",
                              src: _imports_3,
                              class: "w-4 cursor-pointer ml-1",
                              alt: "Download",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDownload('plane')))
                            })
                          ])
                        ]))
                      : (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 3,
                          height: "40px",
                          width: "4rem"
                        }))
                  ]))
                : _createCommentVNode("", true),
              ((_ctx.cargoDisputeSummaryData.totalPlaneData > 0 || _ctx.cargoDisputeSummaryData.totalPlaneDispute > 0) && ((_ctx.cargoDisputeSummaryData.totalTruckData > 0 || _ctx.cargoDisputeSummaryData.totalTruckDispute > 0) || (_ctx.cargoDisputeSummaryData.totalShipData > 0 || _ctx.cargoDisputeSummaryData.totalShipDispute > 0) || (_ctx.cargoDisputeSummaryData.totalTrainData > 0 || _ctx.cargoDisputeSummaryData.totalTrainDispute > 0)))
                ? (_openBlock(), _createBlock("img", _hoisted_26))
                : _createCommentVNode("", true),
              (_ctx.cargoDisputeSummaryData.totalTruckData > 0 || _ctx.cargoDisputeSummaryData.totalTruckDispute > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_27, [
                    (!_ctx.isLoadingCargoDispute)
                      ? (_openBlock(), _createBlock("img", _hoisted_28))
                      : (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 1,
                          height: "30px",
                          width: "30px"
                        })),
                    (!_ctx.isLoadingCargoDispute)
                      ? (_openBlock(), _createBlock("div", _hoisted_29, [
                          _hoisted_30,
                          _createVNode("div", _hoisted_31, [
                            _createVNode("span", _hoisted_32, _toDisplayString(_ctx.cargoDisputeSummaryData.totalTruckDispute) + "/" + _toDisplayString(_ctx.cargoDisputeSummaryData.totalTruckData), 1),
                            _createVNode("span", _hoisted_33, "(" + _toDisplayString(_ctx.formatCurrency(_ctx.cargoDisputeSummaryData.totalTruckPercentage)) + "%)", 1),
                            _createVNode("img", {
                              id: "lp-cargo-list-dispute-summary-download-truck",
                              src: _imports_3,
                              class: "w-4 cursor-pointer ml-1",
                              alt: "Download",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDownload('truck')))
                            })
                          ])
                        ]))
                      : (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 3,
                          height: "40px",
                          width: "4rem"
                        }))
                  ]))
                : _createCommentVNode("", true),
              ((_ctx.cargoDisputeSummaryData.totalTruckData > 0 || _ctx.cargoDisputeSummaryData.totalTruckDispute > 0) && ((_ctx.cargoDisputeSummaryData.totalShipData > 0 || _ctx.cargoDisputeSummaryData.totalShipDispute > 0) || (_ctx.cargoDisputeSummaryData.totalTrainData > 0 || _ctx.cargoDisputeSummaryData.totalTrainDispute > 0)))
                ? (_openBlock(), _createBlock("img", _hoisted_34))
                : _createCommentVNode("", true),
              (_ctx.cargoDisputeSummaryData.totalShipData > 0 || _ctx.cargoDisputeSummaryData.totalShipDispute > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_35, [
                    (!_ctx.isLoadingCargoDispute)
                      ? (_openBlock(), _createBlock("img", _hoisted_36))
                      : (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 1,
                          height: "30px",
                          width: "30px"
                        })),
                    (!_ctx.isLoadingCargoDispute)
                      ? (_openBlock(), _createBlock("div", _hoisted_37, [
                          _hoisted_38,
                          _createVNode("div", _hoisted_39, [
                            _createVNode("span", _hoisted_40, _toDisplayString(_ctx.cargoDisputeSummaryData.totalShipDispute) + "/" + _toDisplayString(_ctx.cargoDisputeSummaryData.totalShipData), 1),
                            _createVNode("span", _hoisted_41, "(" + _toDisplayString(_ctx.formatCurrency(_ctx.cargoDisputeSummaryData.totalShipPercentage)) + "%)", 1),
                            _createVNode("img", {
                              id: "lp-cargo-list-dispute-summary-download-ship",
                              src: _imports_3,
                              class: "w-4 cursor-pointer ml-1",
                              alt: "Download",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDownload('ship')))
                            })
                          ])
                        ]))
                      : (_openBlock(), _createBlock(_component_Skeleton, {
                          key: 3,
                          height: "40px",
                          width: "4rem"
                        }))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.volumeWeightFlag)
                ? (_openBlock(), _createBlock("button", {
                    key: 5,
                    class: "flex flex-row items-center gap-1 text-xs text-red-lp-2000 font-medium",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isExpandMinimumWeightSummary = !_ctx.isExpandMinimumWeightSummary))
                  }, [
                    _hoisted_42,
                    _createVNode(_component_Icons, {
                      name: "chevron-down",
                      class: ["w-4 h-4 transition-all duration-75", [{'transform rotate-180': _ctx.isExpandMinimumWeightSummary}]]
                    }, null, 8, ["class"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", {
            class: ["border-gray-lp-1600 transition-all duration-75", [
          {'border-t pt-1.5 mt-1.5': _ctx.isExpandMinimumWeightSummary},
          {'h-0 overflow-hidden': !_ctx.isExpandMinimumWeightSummary}
        ]]
          }, [
            _createVNode("div", _hoisted_43, [
              _createVNode("div", _hoisted_44, [
                (!_ctx.isLoadingCargoDispute)
                  ? (_openBlock(), _createBlock("img", _hoisted_45))
                  : (_openBlock(), _createBlock(_component_Skeleton, {
                      key: 1,
                      height: "30px",
                      width: "30px"
                    })),
                _hoisted_46
              ]),
              _createVNode("div", _hoisted_47, [
                _createVNode("span", _hoisted_48, _toDisplayString(_ctx.cargoMinimumWeightSummary.totalMinimumVolume) + "/" + _toDisplayString(_ctx.cargoMinimumWeightSummary.totalData), 1),
                _createVNode("span", _hoisted_49, "(" + _toDisplayString(_ctx.formatCurrency(_ctx.cargoMinimumWeightSummary.totalPercentageMinimumVolume)) + "%)", 1),
                _createVNode("img", {
                  id: "lp-cargo-list-dispute-summary-download-ship",
                  src: _imports_3,
                  class: "w-3 cursor-pointer ml-1",
                  alt: "Download",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onDownloadMinimumVolume && _ctx.onDownloadMinimumVolume(...args)))
                })
              ])
            ])
          ], 2)
        ])
      ]))
    : _createCommentVNode("", true)
})